<template>
    <form id="mainFrom" action="#" method="post">
        <card>
            <template #title>
                <Toolbar>
                    <template #left>
                       <div class="p-card-title">
                            [{{ mode }}] {{ $t('Documentation') }}
                        </div>
                        <div style="margin-left: 10px" v-if="mode != this.$FORM_MODE_CREATE">
                            <Button type="button" icon="pi pi-info" @click="toggle" aria:haspopup="true"
                                aria-controls="overlay_panel" class="p-button-rounded p-button-outlined p-button-sm" />
                            <OverlayPanel ref="op" appendTo="body" :showCloseIcon="true" id="overlay_panel"
                                style="width: 550px" :breakpoints="{ '960px': '80vw' }">
                                <div class="grid field">
                                    <div class="row">
                                        <i class="pi pi-plus-circle" /> {{ this.$formatDateTime(header.Created_Date) }}
                                    </div>
                                    <div class="row">
                                        &nbsp;by {{ header.Created_By }}
                                    </div>
                                </div>
                                <div class="grid field" v-if="header.Edited_Date">
                                    <div class="row">
                                        <i class="pi pi-pencil" /> {{ this.$formatDateTime(header.Edited_Date) }}
                                    </div>
                                    <div class="row">
                                        &nbsp;by {{ header.Edited_By }}
                                    </div>
                                </div>
                                <div class="grid field" v-if="header.Deleted_Date">
                                    <div class="row">
                                        <i class="pi pi-trash" /> {{ this.$formatDateTime(header.Deleted_Date) }}
                                    </div>
                                    <div class="row">
                                        &nbsp;by {{ header.Deleted_By }}
                                    </div>
                                </div>
                            </OverlayPanel>
                        </div>
                    </template>
                    <template #right>
                        <Button icon="pi pi-chevron-left" label="Back" class="p-button mr-2" @click="backToIndex" />
                        <Button icon="pi pi-upload" label="Save" class="p-button-success" @click="confirm($event)" v-if="mode != this.$FORM_MODE_DELETE && mode != this.$FORM_MODE_VIEW" />
                        <Button icon="pi pi-trash" label="Delete" class="p-button-danger" @click="confirm($event)"
                            v-if="mode == this.$FORM_MODE_DELETE" />
                        <ConfirmPopup></ConfirmPopup>
                    </template>
                </Toolbar>
            </template>
            <template #content>
                <div class="p-inputtext-sm p-fluid">
                    <div class="grid">
                        <div class="col-6">
                            <div class="field grid">
                                <label for="Category" class="col-4">{{ $t('category') }}<span style="color: red;">*</span></label>
                                <div class="col-8 md-8">
                                <CustomSelect 
                                        class="p-inputtext-sm"
                                        name="Category"
                                        v-model="header.Category"
                                        :url="$API_URL + 'list/lookup'"
                                        :params="{ group: this.$LOOKUP_GROUP.CATEGORY_DOCUMENT }"
                                        :minLength="0"
                                        :filter="true"
                                        :placeholder="$t('category')"
                                        :disabled="mode != this.$FORM_MODE_CREATE"
                                        />
       
                                    <small v-if="header && !header.Category && submitted && mode != this.$FORM_MODE_DELETE"
                                        class="p-error">{{ $t('is_required').replace('Value', $t('category')) }}
                                    </small>
                                </div>
                            </div>
                            <div class="field grid">
                                <label for="Document_Name" class="col-4">{{ $t('document_name') }}<span style="color: red;">*</span></label>
                                <div class="col-8 md-8">
                                    <InputText name="Document_Name" v-model="header.Document_Name" type="text" :placeholder="$t('document_name')"
                                        v-if="header"
                                        :disabled="mode == this.$FORM_MODE_DELETE || mode == this.$FORM_MODE_VIEW"
                                        />
                                    <Skeleton v-else-if="!header" />
                                    <small v-if="header && !header.Document_Name && submitted && mode != this.$FORM_MODE_DELETE"
                                        class="p-error">{{ $t('is_required').replace('Value', $t('document_name')) }}
                                    </small>
                                </div>
                            </div>
                            <div class="field grid">
                                <label for="Attachment" class="col-4">{{ $t('attachment') }}</label>
                                <div class="col-8 md-8">
                                        <input
                                            type="file"
                                            id="attachments"
                                            class="p-inputtext p-component w-full"
                                            accept=".xlsx,.xls,.pdf"
                                            :multiple="false"
                                            :disabled="mode != this.$FORM_MODE_CREATE && mode != this.$FORM_MODE_EDIT"
                                            @change="onFileChange($event, header)"
                                        />
                                        <input
                                            v-if="mode != this.$FORM_MODE_CREATE"
                                            type="text"
                                            class="p-inputtext p-component w-full mt-2"
                                            :value="header.file_name"
                                            :disabled="true"
                                        />
                                        <small v-if="mode == this.$FORM_MODE_CREATE && (!header.files_data || header.files_data.length == 0) && submitted"
                                            class="p-error">{{ $t('is_required').replace('Value', $t('attachment')) }}
                                        </small>
                                </div>
                            </div>
                        </div>
                        <div class="col-6" v-if="mode == this.$FORM_MODE_EDIT">
                            <FormField :labelName="$t('reason')" fieldName="Reason" v-model="header" labelClass="col-4" fieldClass="col-8 md-8" v-if="header">
                                <InputText name="Reason" v-model="header.Reason" type="text" :placeholder="$t('reason')" 
                                v-if="header" :disabled="mode != this.$FORM_MODE_EDIT"/>
                                <small v-if="header && !header.Reason && submitted && mode != this.$FORM_MODE_DELETE"
                                    class="p-error">{{ $t('is_required').replace('Value', $t('reason')) }}
                                </small>
                            </FormField>
                        </div>
                    </div>
                    <div class="col-12 mt-4" v-if="this.mode != this.$FORM_MODE_CREATE">
                         <TabView>
                                <TabPanel :header="$t('log_history')">
                                    <ChangeHistory v-if="this.header" :modelValue="this.dataModelReqLogs"
                                        :dataRequestLog="this.dataRequestLogs" :mode="this.mode"></ChangeHistory>
                                </TabPanel>
                                 <TabPanel :header="$t('Change_History')">
                                    <ChangeHistory v-if="this.header" :modelValue="this.detailLog" :dataRequestLog="this.dataChangesLog" :mode="this.mode"></ChangeHistory>
                                </TabPanel>
                            </TabView>
                    </div>
                </div>
            </template>
        </card>
    </form>
</template>
<script>
export default {
    name: "Editor",
    data() {
        return {
            indexName: "DocumentationIndex",
            url: this.$API_URL + "Documentation/",
            header: {
                Category: null,
                files_data: []
            },
            detail: null,
            mode: "",
            submitted: false,
            id: 0,
            formEditable: true,
            dataChangesLog:this.$dataChangesLogMasterData,
            detailLog : null,
            dataModelReqLogs: [],
            dataRequestLogs: [
                { field: "Action_Role", header: "Role" },
                { field: "Action_By", header: "Action By" },
                { field: "Action", header: "Action" },
                { field: "Action_Date", header: "Action Date" },
                { field: "Notes", header: "Notes" },
            ],
        }
    },
    methods: {
        getData() {
            var self = this;
            this.$axios.get(this.url + this.id + "/" + this.mode)
                .then((response) => {
                    self.header = response.data.data.header;
                    self.header.mode = self.mode;
                    self.dataModelReqLogs = response.data.data.header.request_log;
                    self.detailLog = self.header.DetailLog;
                })
                .catch(function (error) {
                    alert(error);
                });
        },
        onFileChange(event, header) {
            const files = event.target.files;
            if (files && files.length > 0) {
            header.files_data = [files[0]]; 
            } else {
            header.files_data = [];
            }
        },
        saveData() {
            this.$emit('block-ui');
            var self = this;
            var data = new FormData();
            data.append("Id", this.header.Id);
            data.append("mode", this.header.mode);
            if(this.header.Category != null)
                data.append("Category", this.header.Category);
            if(this.header.Document_Name != null)
                data.append("Document_Name", this.header.Document_Name);
            if(this.header.Reason != null)
                data.append("Reason", this.header.Reason);
            if (this.header.files_data != null && this.header.files_data.length > 0) {
                let file = this.header.files_data[0];
                data.append("attachments.File", file, file.name);
            }

            this.$axios.post(this.url, data, 
                    {
                        headers: {
                            'Content-Type': 'multipart/form-data'
                        }
                    })
                .then((response) => {
                    if (response.data.success) {
                        if (this.mode == this.$FORM_MODE_DELETE) {
                            self.$router.push({ name: self.indexName, params: { showToast: true, severity: 'success', summary: 'Data Deleted', detail: "Document has been deleted successfully", life: 3000 } });
                        } else {
                            self.$router.push({ name: self.indexName, params: { showToast: true, severity: 'success', summary: 'Data Saved', detail: "Document has been saved successfully", life: 3000 } });
                        }

                    }
                    else {
                        self.showError('Error Saving Data', response.data.message);
                    }
                })
                .catch(function (error) {
                    self.showError('Error Saving Data', error);
                });
        },
        showError(summary, message) {
            this.$emit('unblock-ui');
            this.$toast.add({ severity: 'error', summary: summary, detail: message, life: 3000 });
        },
        backToIndex() {
            this.$router.push({ path: "/Documentation/Index" });
        },
        toggle(event) {
            this.$refs.op.toggle(event);
        },
        confirm(event) {
            this.submitted = true;
            var self = this;
            if (!this.header.Category || !this.header.Document_Name || (this.header.mode == self.$FORM_MODE_EDIT && !this.header.Reason) || (this.header.mode == self.$FORM_MODE_CREATE && (!this.header.files_data || this.header.files_data.length == 0))) {
                this.$toast.add({ severity: 'error', summary: 'Error', detail: 'Please fill all required fields', life: 3000 });
                return;
            }
            
            this.$confirm.require({
                target: event.currentTarget,
                message: 'Are you sure?',
                icon: 'pi pi-exclamation-triangle',
                accept: () => {
                    this.saveData();
                },
                reject: () => {

                }
            });
            
        },
    },
    created() {
        this.mode = this.$route.query.mode;
        this.id = this.$route.query.id ?? 0;

        this.getData();
    }
};
</script>